exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-gallery[data-v-6df18443]{text-align:center;width:100%;height:100%;display:flex;align-items:center;min-height:calc(90vw * 1.1)}@media only screen and (min-width: 768px){.media-gallery[data-v-6df18443]{min-height:inherit}}.media-gallery--loaded[data-v-6df18443]{background-image:none}\n", ""]);

// exports
